import { Controller } from '@hotwired/stimulus'

// Dismissible seller tip cards (price / category coaching). Remembers via localStorage.
export default class extends Controller {
  static values = {
    key: String
  }

  connect () {
    if (!this.keyValue) return
    if (window.localStorage.getItem(this.storageKey()) === '1') {
      this.element.classList.add('hidden')
    }
  }

  dismiss (event) {
    event?.preventDefault()
    try {
      window.localStorage.setItem(this.storageKey(), '1')
    } catch (_) {
      // private mode / blocked storage — still hide for this visit
    }
    this.element.classList.add('seller-tip--out')
    window.setTimeout(() => {
      this.element.classList.add('hidden')
    }, 220)
  }

  storageKey () {
    return `ebazzari.seller_tip.${this.keyValue}`
  }
}
